import React, { memo, useState, useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { SiTether, SiStellar, SiLitecoin, SiZcash, SiBitcoin, SiCardano, SiBinance, SiDogecoin } from "react-icons/si";
import { useNavigate } from "react-router-dom";

const Footer = memo(() => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem("language") || "ID");

    useEffect(() => {
        const currentLang = i18n.language.toUpperCase();
        const expectedLang = selectedLanguage.toUpperCase();
        if (currentLang !== expectedLang) {
            setSelectedLanguage(currentLang);
        }
    }, [i18n.language, selectedLanguage]);

    const cryptoIcons = useMemo(() => [
        { icon: <SiTether className="size-lg text-dropdown-bg" />, name: "USDT" },
        { icon: <SiStellar className="size-lg text-dropdown-bg" />, name: "XLM" },
        { icon: <SiLitecoin className="size-lg text-dropdown-bg" />, name: "LTC" },
        { icon: <SiZcash className="size-lg text-dropdown-bg" />, name: "ZEC" },
        { icon: <SiBitcoin className="size-lg text-dropdown-bg" />, name: "BTC" },
        { icon: <SiCardano className="size-lg text-dropdown-bg" />, name: "ADA" },
        { icon: <SiBinance className="size-lg text-dropdown-bg" />, name: "BNB" },
        { icon: <SiDogecoin className="size-lg text-dropdown-bg" />, name: "DOGE" }
    ], []);

    return (
        <div className="p-4 bg-primary lg:bg-[#002B43] lg:p-6">
            <div className="mb-6 flex-center gap-2">
                {cryptoIcons.map((crypto) => (
                    <div
                        key={crypto.name}
                        className="flex-center size-xl lg:h-12 lg:w-12 lg:rounded-full lg:bg-[#04537F] lg:transition-transform lg:duration-300 lg:ease-[cubic-bezier(0.22,1,0.36,1)] lg:hover:-translate-y-0.5 lg:active:scale-[0.98]"
                        onClick={() => navigate("/deposit")}
                    >
                        {crypto.icon}
                    </div>
                ))}
            </div>

            <div className="flex-between text-color-blue">
                <span className="text-xs lg:text-sm">
                    {t("copyright")}
                </span>
                <span className="text-xs lg:text-sm">
                    {t("18+")}
                </span>
            </div>
        </div>
    );
});

export default Footer;